import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, NavigationEnd, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { UsuariosService } from '../usuarios/usuarios.service';
import { environment } from 'src/environments/environment';
import { PerfilamientoService } from '../perfilamiento/perfilamiento.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardGuard implements CanActivate {
  currUrl: string | null = null
  constructor (
    private _usuarios: UsuariosService,
    private _perfilamiento: PerfilamientoService,
    private router: Router
  ) {
    this.router.events.subscribe((event) => { 
      if ( event instanceof NavigationEnd ) {
        this.currUrl = event.url
      }
    })
  }

  urlDisponible() {
    let urlDisponible = false
    const menu = this._perfilamiento.getMenu()
    if ( menu?.modulos ) {
      menu.modulos.forEach((modulo: any) => {
        if ( modulo.menus?.length > 0 ) {
          modulo.menus.forEach((menu: any) => {
            if ( `/${menu.url}` === this.currUrl ) {
              urlDisponible = true
            }
          })
        }
      })
    }
    return urlDisponible
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree 
  {
    if ( !this._usuarios.getToken() ) {
      if ( environment.devLocal ) {
        this.router.navigateByUrl('/login')
      } else {
        window.location.href = environment.loginUrl
      }
      return false
    }

    return true
  }
  
}
